import * as React from "react";
import { createContext, useState, useContext } from "react";

const ErrorContext = createContext();

export const useErrorContext = () => useContext(ErrorContext);

export const ErrorContextProvider = ({ children }) => {
  const [isLoading, setLoading] = useState(true);
  const [isError, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  return (
    <ErrorContext.Provider value={{ isLoading, setLoading, isError, setError, errorMessage, setErrorMessage }}>
      {children}
    </ErrorContext.Provider>
  );
};
